import { callApi } from 'utils/api';

export function fetchAuthenticationApi(domainName) {
  return callApi(`authentication/${domainName}`);
}
